<template>
  <div class="overflow-hidden" style="--animation-direction: reverse; --animation-duration: 30s">
    <div
      class="flex overflow-auto snap-x snap-mandatory no-scrollbar gap-5 px-5 scroll-pl-5 md:animate-carousel-reverse md:px-0 md:overflow-visible md:will-change-transform md:w-max"
      ref="container"
      @scroll.passive="handleScroll"
    >
      <div
        v-for="i in 4"
        :class="['contents', { 'hidden! md:contents!': i > 1 }]"
        :key="`carousel-${i}`"
      >
        <component
          :is="image.link ? 'SiteLink' : 'div'"
          v-for="(image, imageIndex) in images"
          :key="`image-${imageIndex}`"
          :content="image.link ? { link: image.link } : undefined"
          class="aspect-square snap-start w-full shrink-0 md:w-97.5 md:h-87.5"
        >
          <ResponsiveImage
            :media="image.image"
            :title="image.title"
            class="w-full h-full object-cover"
          />
        </component>
      </div>
    </div>
    <div class="flex items-center justify-center py-5 gap-1 md:hidden">
      <button
        @click.stop="goTo(i - 1)"
        v-for="i in images.length"
        :key="`image-dot-${i}`"
        :class="[
          'w-2 h-2 rounded-full bg-pink block transition-[background-color] cursor-pointer',
          {
            'bg-dustrose!': dark && i - 1 === current,
            'bg-burgundy!': !dark && i - 1 === current,
          },
        ]"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { type PropType, ref } from 'vue'

import IconSprite from '@/components/helpers/IconSprite.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'
import SiteLink from '@/components/helpers/SiteLink.vue'
import { useCarousel } from '@/composables/useCarousel.ts'

export default {
  name: 'ImagesCarousel',
  components: { IconSprite, ResponsiveImage, SiteLink },
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    images: {
      type: Array as PropType<CarouselCard[]>,
      required: true,
    },
  },
  setup(props) {
    const container = ref<HTMLDivElement | null>(null)

    const { current, goTo, handleScroll } = useCarousel(props.images.length - 1, container)

    return { container, current, goTo, handleScroll }
  },
}
</script>
